import { isEqual, omit } from 'lodash';
import { MutableRefObject, useEffect, useRef, useState } from 'react';

import { GridApiPro, GridLogicOperator } from '@mui/x-data-grid-pro';

import TableModels from '../types/tableModels.type';
import convertModel from '../utils/convertModel';

type Search =
  | {
      [x: string]: {
        value: string;
        cop: string[];
        op: GridLogicOperator | undefined;
      };
    }[]
  | {
      [x: string]: {
        value: string;
        cop: string[];
        op: GridLogicOperator | undefined;
      };
    }[][];

type Args = {
  model: TableModels;
  apiRef: MutableRefObject<GridApiPro>;
};

const usePrepareRequestBody = ({ model, apiRef }: Args) => {
  const modelRef = useRef<typeof model | null>(null);

  const [requestBody, setRequestBody] = useState<{
    sort_order: string;
    page: number;
    page_size: number;
    search: Search;
  }>({
    sort_order: 'desc',
    page: 0,
    page_size: 25,
    search: [],
  });

  useEffect(() => {
    if (
      !isEqual(
        omit(model, ['rowSelectionModel']),
        omit(modelRef.current, ['rowSelectionModel']),
      )
    ) {
      modelRef.current = model;

      setRequestBody((prev) => ({
        ...prev,
        page: model.paginationModel.page,
        page_size: model.paginationModel.pageSize,
        search: convertModel({
          model: model.filterModel,
          columns: apiRef.current.getAllColumns(),
        }) as Search,
      }));
    }
  }, [apiRef, model]);

  return { requestBody };
};

export default usePrepareRequestBody;
